import React, { useEffect, useState } from "react";
import Keycloak from 'keycloak-js';
import { useCookies } from 'react-cookie';

// Initialize Keycloak instance with your configuration
const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
});

function LoginForm() {
  const [authenticated, setAuthenticated] = useState(false);
   const [cookies, setCookie, removeCookies] = useCookies();
   
   const cookieOptions = {
     domain: '.'+(process.env.REACT_APP_ROOT_DOMAIN || 'alpide.com'), // Replace with your desired domain
     path: '/', // Replace with the desired path
     expires: new Date(Date.now() + 86400 * 1000), // Replace with the desired expiration time
   };

   const getValidURL = (source, country) => {
    let url;
    if(window.location.hostname === 'localhost'){
      country= "Localhost";
    }else if(!country || process.env.REACT_APP_ROOT_DOMAIN === "alpidedev.com" ){
      country= "Dev"
    }
  let countryURIList = JSON.parse(process.env.REACT_APP_ERP_APP_URI_LIST || "{}");
    switch (source) {
      case 'erpApp': {
        url = countryURIList[country]? countryURIList[country] : '';
          break;
      }
      default: {
        url= countryURIList[country];
      }
  }
  return url;
  }
  const urlParams = new URLSearchParams(window.location.search);


  // Get the value of the 'code' parameter
  let source = urlParams.get("source");

  // keycloak.init({ onLoad: 'login-required', checkLoginIframe: false })
  //   .then((authenticated) => {
  //     if (!authenticated) {
  //       console.warn('Not authenticated!');
  //       keycloak.login();
  //       return;
  //     }
  //   });
  // const country = (keycloak.tokenParsed)?.country;
  // console.log('Logged in, country = ', country);

  // console.log('Logged in, keycloak.tokenParsed = ', keycloak.tokenParsed);
  // console.log('Logged in, keycloak = ', keycloak);
  // console.log('Logged in, keycloakkeycloak?.ho.url = ', keycloak?.['ho.url']);
  // console.log('Logged in, keycloakkeycloak?.ho.url = ', keycloak?.['ho.url']?.tokenParsed);
  // console.log('Logged in, keycloak?.ho?.url?.tokenParsed = ', keycloak?.ho?.url?.tokenParsed);
  


  // const parseJwt = (token) => {
  //   const base64Url = token.split('.')[1];
  //   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //   return JSON.parse(atob(base64));
  // }

useEffect(() => {
    keycloak.init({ 
      onLoad: 'login-required', 
      checkLoginIframe: false 
    }).then((auth) => {
      setAuthenticated(auth);
      
      if (auth) {
        // Access token data
        console.log("auth :::: ", auth);
        const tokenData = keycloak.tokenParsed;
        console.log("sdsfd :::: ", tokenData);
         console.log("sdsfd String :::: ", JSON.stringify(tokenData));
        console.log("keycloak.token :::: ", keycloak.token);
        console.log("keycloak :::: ", keycloak);
        const accessToken = keycloak.token;

        const refreshToken = keycloak.refreshToken;


        // Optionally load full user profile
        keycloak.loadUserProfile().then((profile) => {
          console.log('Full Profile:', profile);
        });

        setCookie('access_token', accessToken, cookieOptions);
        setCookie('refresh_token', refreshToken, cookieOptions);
        setCookie('expires_in', tokenData.exp, cookieOptions);
        setCookie('email', tokenData.email, cookieOptions);
        setCookie('idToken', keycloak.idToken, cookieOptions);
        setCookie('country', tokenData.country, cookieOptions);

        // ad logic for country specific 
        let redirectUri = getValidURL(source, tokenData?.country);
        console.log("redirect URI ", redirectUri);
        window.location = redirectUri;
      }
    }).catch((error) => {
      console.error('Keycloak init failed:', error);
    });
  }, []);

    // Optionally redirect purely on the front-end based on country
    
  useEffect(() => {
  
  //  window.location = `${process.env.REACT_APP_AUTH_REDIRECT_URL}?response_type=${process.env.REACT_APP_RESPONSE_TYPE}&client_id=${process.env.REACT_APP_CLIENT_ID}&state=test&scope=${process.env.REACT_APP_SCOPE}&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}?source=${source}`;
   // let redirectUri = encodeURIComponent(`${process.env.REACT_APP_REDIRECT_URI}?source=${source}`);
    //console.log(`${process.env.REACT_APP_AUTH_REDIRECT_URL}?response_type=${process.env.REACT_APP_RESPONSE_TYPE}&client_id=${process.env.REACT_APP_CLIENT_ID}&state=test&scope=${process.env.REACT_APP_SCOPE}&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}?source=${source}`);
   // window.location = `${process.env.REACT_APP_AUTH_REDIRECT_URL}?response_type=${process.env.REACT_APP_RESPONSE_TYPE}&client_id=${process.env.REACT_APP_CLIENT_ID}&state=test&scope=${process.env.REACT_APP_SCOPE}&redirect_uri=`+redirectUri;
 
  }, [source]);

  return (
    <div style={{
      height: "100vh",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    }}>
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  );
}

export default LoginForm;
